"use strict";
exports.__esModule = true;
exports.parseMuiTheme = exports.parseThemeTemplate = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var fp_1 = tslib_1.__importDefault(require("lodash/fp"));
var DefaultEpilotTheme_1 = require("./DefaultEpilotTheme");
var fonts_1 = tslib_1.__importDefault(require("./fonts"));
function parseThemeTemplate(params) {
    var _a, _b, _c, _d;
    return {
        contentMaxWidth: (((_a = params.props) === null || _a === void 0 ? void 0 : _a.content_max_width) || ((_b = DefaultEpilotTheme_1.DefaultEpilotTheme.props) === null || _b === void 0 ? void 0 : _b.content_max_width)) + "px",
        clientLogoUrl: ((_c = params.props) === null || _c === void 0 ? void 0 : _c.client_logo_url) || ((_d = DefaultEpilotTheme_1.DefaultEpilotTheme.props) === null || _d === void 0 ? void 0 : _d.client_logo_url),
        clientLogoStyle: {
            height: '32px'
        }
    };
}
exports.parseThemeTemplate = parseThemeTemplate;
function parseMuiTheme(params, classPrefix) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210;
    if (classPrefix === void 0) { classPrefix = ''; }
    var prefix = classPrefix ? classPrefix + "-" : '';
    var disableRipple = typeof ((_t = params.props) === null || _t === void 0 ? void 0 : _t.enable_ripple) === 'boolean'
        ? !((_u = params.props) === null || _u === void 0 ? void 0 : _u.enable_ripple)
        : !((_v = DefaultEpilotTheme_1.DefaultEpilotTheme.props) === null || _v === void 0 ? void 0 : _v.enable_ripple);
    var borderRadius = ((_w = params.shape) === null || _w === void 0 ? void 0 : _w.borderRadius) || ((_x = DefaultEpilotTheme_1.DefaultEpilotTheme.shape) === null || _x === void 0 ? void 0 : _x.borderRadius);
    var primaryColor = ((_y = params.palette) === null || _y === void 0 ? void 0 : _y.primary) || ((_z = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _z === void 0 ? void 0 : _z.primary);
    var secondaryColor = ((_0 = params.palette) === null || _0 === void 0 ? void 0 : _0.secondary) || ((_1 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _1 === void 0 ? void 0 : _1.secondary);
    var successColor = ((_2 = params.palette) === null || _2 === void 0 ? void 0 : _2.success) || ((_3 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _3 === void 0 ? void 0 : _3.success);
    var infoColor = ((_4 = params.palette) === null || _4 === void 0 ? void 0 : _4.info) || ((_5 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _5 === void 0 ? void 0 : _5.info);
    var defaultBackground = ((_7 = (_6 = params.palette) === null || _6 === void 0 ? void 0 : _6.background) === null || _7 === void 0 ? void 0 : _7["default"]) || ((_9 = (_8 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _8 === void 0 ? void 0 : _8.background) === null || _9 === void 0 ? void 0 : _9["default"]);
    var warningColor = ((_10 = params.palette) === null || _10 === void 0 ? void 0 : _10.warning) || ((_11 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _11 === void 0 ? void 0 : _11.warning);
    var primaryDark = (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.dark) ? primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.dark : (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main) ? styles_1.darken(primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main, 0.1)
        : null;
    var secondaryDark = (secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.dark) ? secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.dark : (secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main) ? styles_1.darken(secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main, 0.1)
        : null;
    var primaryLight = (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.light) ? primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.light : (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main) ? styles_1.lighten(primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main, 0.1)
        : null;
    var secondaryLight = (secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.light) ? secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.light : (secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main) ? styles_1.lighten(secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main, 0.1)
        : null;
    var errorColor = ((_12 = params.palette) === null || _12 === void 0 ? void 0 : _12.error) || ((_13 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _13 === void 0 ? void 0 : _13.error);
    var accent1Color = ((_14 = params.palette) === null || _14 === void 0 ? void 0 : _14.accent1) || ((_15 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _15 === void 0 ? void 0 : _15.accent1);
    var accent2Color = ((_16 = params.palette) === null || _16 === void 0 ? void 0 : _16.accent2) || ((_17 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _17 === void 0 ? void 0 : _17.accent2);
    var tertiaryColor = ((_18 = params.palette) === null || _18 === void 0 ? void 0 : _18.tertiary) || ((_19 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _19 === void 0 ? void 0 : _19.tertiary);
    var defaultColor = ((_20 = params.palette) === null || _20 === void 0 ? void 0 : _20["default"]) || ((_21 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _21 === void 0 ? void 0 : _21["default"]);
    var grey20 = ((_23 = (_22 = params.palette) === null || _22 === void 0 ? void 0 : _22.grey) === null || _23 === void 0 ? void 0 : _23[20]) || ((_25 = (_24 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _24 === void 0 ? void 0 : _24.grey) === null || _25 === void 0 ? void 0 : _25[20]);
    var grey30 = ((_27 = (_26 = params.palette) === null || _26 === void 0 ? void 0 : _26.grey) === null || _27 === void 0 ? void 0 : _27[30]) || ((_29 = (_28 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _28 === void 0 ? void 0 : _28.grey) === null || _29 === void 0 ? void 0 : _29[30]);
    var grey40 = ((_31 = (_30 = params.palette) === null || _30 === void 0 ? void 0 : _30.grey) === null || _31 === void 0 ? void 0 : _31[40]) || ((_33 = (_32 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _32 === void 0 ? void 0 : _32.grey) === null || _33 === void 0 ? void 0 : _33[40]);
    var grey50 = ((_35 = (_34 = params.palette) === null || _34 === void 0 ? void 0 : _34.grey) === null || _35 === void 0 ? void 0 : _35[50]) || ((_37 = (_36 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _36 === void 0 ? void 0 : _36.grey) === null || _37 === void 0 ? void 0 : _37[50]);
    var grey60 = ((_39 = (_38 = params.palette) === null || _38 === void 0 ? void 0 : _38.grey) === null || _39 === void 0 ? void 0 : _39[60]) || ((_41 = (_40 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _40 === void 0 ? void 0 : _40.grey) === null || _41 === void 0 ? void 0 : _41[60]);
    var grey70 = ((_43 = (_42 = params.palette) === null || _42 === void 0 ? void 0 : _42.grey) === null || _43 === void 0 ? void 0 : _43[70]) || ((_45 = (_44 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _44 === void 0 ? void 0 : _44.grey) === null || _45 === void 0 ? void 0 : _45[70]);
    var grey100 = ((_47 = (_46 = params.palette) === null || _46 === void 0 ? void 0 : _46.grey) === null || _47 === void 0 ? void 0 : _47[100]) || ((_49 = (_48 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _48 === void 0 ? void 0 : _48.grey) === null || _49 === void 0 ? void 0 : _49[100]);
    var grey200 = ((_51 = (_50 = params.palette) === null || _50 === void 0 ? void 0 : _50.grey) === null || _51 === void 0 ? void 0 : _51[200]) || ((_53 = (_52 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _52 === void 0 ? void 0 : _52.grey) === null || _53 === void 0 ? void 0 : _53[200]);
    var grey500 = ((_55 = (_54 = params.palette) === null || _54 === void 0 ? void 0 : _54.grey) === null || _55 === void 0 ? void 0 : _55[500]) || ((_57 = (_56 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _56 === void 0 ? void 0 : _56.grey) === null || _57 === void 0 ? void 0 : _57[500]);
    var textPalette = ((_58 = params.palette) === null || _58 === void 0 ? void 0 : _58.text) || ((_59 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _59 === void 0 ? void 0 : _59.text);
    var actionHoverColor = ((_61 = (_60 = params.palette) === null || _60 === void 0 ? void 0 : _60.action) === null || _61 === void 0 ? void 0 : _61.hover) || ((_63 = (_62 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _62 === void 0 ? void 0 : _62.action) === null || _63 === void 0 ? void 0 : _63.hover);
    var dividerColor = ((_64 = params.palette) === null || _64 === void 0 ? void 0 : _64.divider) || ((_65 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _65 === void 0 ? void 0 : _65.divider);
    var extFonts = ((_66 = params.typography) === null || _66 === void 0 ? void 0 : _66.fontSource) ? fonts_1["default"].concat((_67 = params.typography) === null || _67 === void 0 ? void 0 : _67.fontSource)
        : fonts_1["default"];
    var elevation1 = ((_68 = params.shadows) === null || _68 === void 0 ? void 0 : _68[1]) || ((_69 = DefaultEpilotTheme_1.DefaultEpilotTheme.shadows) === null || _69 === void 0 ? void 0 : _69[1]);
    var elevation2 = ((_70 = params.shadows) === null || _70 === void 0 ? void 0 : _70[2]) || ((_71 = DefaultEpilotTheme_1.DefaultEpilotTheme.shadows) === null || _71 === void 0 ? void 0 : _71[2]);
    var elevation3 = ((_72 = params.shadows) === null || _72 === void 0 ? void 0 : _72[3]) || ((_73 = DefaultEpilotTheme_1.DefaultEpilotTheme.shadows) === null || _73 === void 0 ? void 0 : _73[3]);
    var elevation8 = ((_74 = params.shadows) === null || _74 === void 0 ? void 0 : _74[8]) || ((_75 = DefaultEpilotTheme_1.DefaultEpilotTheme.shadows) === null || _75 === void 0 ? void 0 : _75[8]);
    var overrides = fp_1["default"].merge({
        MuiTypography: {
            root: {
                textTransform: 'none'
            }
        },
        MuiInputBase: {
            input: {
                height: 'auto',
                '&::placeholder': {
                    color: grey200,
                    opacity: 1
                },
                '&$disabled': {
                    '&::placeholder': {
                        color: grey100
                    }
                }
            }
        },
        MuiInputAdornment: {
            root: (_a = {},
                _a["& ." + prefix + "MuiIconButton-root"] = {
                    padding: 0
                },
                _a)
        },
        MuiInput: {
            underline: {
                '&:before': {
                    borderBottom: "1px solid " + grey60
                },
                '&:after': {
                    borderBottom: "1px solid " + (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400])
                },
                '&:hover:not(.Mui-disabled)': {
                    '&:before': {
                        borderBottom: "1px solid " + grey60
                    }
                },
                '&$disabled': {
                    '&:before': {
                        borderBottomStyle: 'solid'
                    }
                }
            }
        },
        MuiSelect: {
            root: {
                textAlign: 'start'
            },
            icon: {
                color: secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main
            }
        },
        MuiFormHelperText: {
            contained: {
                marginLeft: '1px'
            }
        },
        MuiInputLabel: {
            root: {
                color: grey500 + " !important",
                '&$disabled': {
                    color: grey100 + " !important"
                }
            },
            outlined: {
                display: 'none'
            }
        },
        MuiPaper: {
            elevation1: {
                boxShadow: elevation1
            },
            elevation2: {
                boxShadow: elevation2
            },
            elevation3: {
                boxShadow: elevation3
            },
            // Elevation8 affects Popover default boxShadow
            elevation8: {
                boxShadow: elevation8
            }
        },
        MuiChip: {
            root: {
                borderRadius: 2,
                fontSize: 12,
                fontWeight: 600,
                height: 24,
                backgroundColor: grey50,
                lineHeight: 'normal',
                color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,filter 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
            },
            colorPrimary: {
                color: 'white'
            },
            colorSecondary: {
                color: 'white'
            },
            outlined: (_b = {
                    backgroundColor: 'transparent',
                    '&:hover': {
                        border: "1px solid " + (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main)
                    }
                },
                _b["& ." + prefix + "MuiIcon-root, ." + prefix + "MuiSvgIcon-root"] = {
                    color: secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main
                },
                _b),
            clickable: {
                '&:hover, &:active, &:focus': {
                    backgroundColor: grey50,
                    filter: 'brightness(92%)'
                }
            },
            clickableColorPrimary: {
                '&:hover, &:active, &:focus': {
                    background: primaryColor,
                    filter: 'brightness(92%)'
                }
            },
            clickableColorSecondary: {
                '&:hover, &:active, &:focus': {
                    background: secondaryColor,
                    filter: 'brightness(92%)'
                }
            },
            deletable: {
                '&:hover, &:active, &:focus': {
                    backgroundColor: grey50
                }
            },
            icon: {
                fontSize: '1.2rem !important'
            },
            deleteIcon: {
                fontSize: '1.2rem !important',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        },
        MuiAccordionDetails: {
            root: {
                backgroundColor: grey20,
                borderTop: "1px solid " + grey50
            }
        },
        MuiAccordionSummary: {
            root: {
                color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                fontSize: 14,
                fontWeight: 600,
                minHeight: 48,
                '&$expanded': {
                    minHeight: 48
                }
            },
            content: {
                '&$expanded': {
                    margin: 'auto'
                }
            },
            expanded: {}
        },
        MuiAccordion: {
            root: {
                marginTop: '-1px !important',
                '&$expanded': {
                    margin: 'auto',
                    '&:before': {
                        top: -1,
                        left: 0,
                        right: 0,
                        height: 1,
                        content: '',
                        opacity: 1,
                        position: 'absolute',
                        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        backgroundColor: grey50
                    }
                },
                '&.Mui-disabled': {
                    backgroundColor: grey40
                }
            }
        },
        MuiRadio: {
            colorPrimary: {
                '&:hover': {
                    color: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main,
                    backgroundColor: 'transparent'
                }
            },
            colorSecondary: {
                '&:hover': {
                    color: accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.main,
                    backgroundColor: 'transparent'
                }
            }
        },
        MuiCheckbox: {
            colorPrimary: {
                '&:hover': {
                    color: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main,
                    backgroundColor: 'transparent'
                }
            },
            colorSecondary: {
                '&:hover': {
                    color: accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.main,
                    backgroundColor: 'transparent'
                }
            }
        },
        MuiTabPanel: {
            root: (_c = {
                    padding: 0
                },
                _c["& ." + prefix + "MuiPaper-root"] = {
                    borderRadius: "0px " + borderRadius + "px " + borderRadius + "px " + borderRadius + "px"
                },
                _c)
        },
        MuiTabs: {
            root: {
                minHeight: 40,
                overflow: 'visible'
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: "1px solid " + grey60,
                whiteSpace: 'pre',
                height: 48
            },
            head: {
                fontWeight: 600,
                height: 56,
                border: 0
            },
            stickyHeader: {
                fontWeight: 600,
                backgroundColor: grey30,
                left: 'unset'
            }
        },
        MuiTableSortLabel: {
            root: {
                '&:hover': {
                    color: 'inherit'
                }
            }
        },
        MuiTableRow: {
            root: {
                '&$selected': {
                    backgroundColor: grey20 + " !important"
                }
            },
            hover: {
                '&:hover': {
                    backgroundColor: grey20 + " !important"
                }
            }
        },
        MuiTableHead: {
            root: {
                backgroundColor: grey30
            }
        },
        MuiButton: {
            root: {
                fontWeight: 600,
                '&$disabled': {
                    color: grey100
                },
                height: 32,
                fontSize: 14
            },
            sizeSmall: {
                height: 24,
                fontSize: 12
            },
            sizeLarge: {
                height: 48,
                fontSize: 16
            },
            contained: {
                '&$disabled': {
                    color: grey100,
                    backgroundColor: grey40
                }
            },
            text: {
                color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            },
            textPrimary: (_d = {
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[600]
                    },
                    '&:active': {
                        color: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[700]
                    }
                },
                _d["&." + classPrefix + "Mui-focusVisible"] = {
                    border: "1px solid white",
                    boxShadow: "0 0 0 2px " + ((primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) || primaryLight) + " !important"
                },
                _d["&." + classPrefix + "Mui-focusVisible." + classPrefix + "MuiButton-textSizeSmall"] = {
                    boxShadow: "0 0 0 1px " + ((primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) || primaryLight) + " !important"
                },
                _d),
            textSecondary: {
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            },
            outlined: (_e = {
                    color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                    backgroundColor: defaultBackground,
                    borderColor: grey70,
                    '&:active': {
                        borderColor: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400],
                        boxShadow: "0px 0px 0px 1px " + (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) + " !important"
                    }
                },
                _e["& ." + prefix + "MuiButton-startIcon"] = {
                    color: accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.main
                },
                _e["& ." + prefix + "MuiButton-endIcon"] = {
                    color: accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.main
                },
                _e["&." + classPrefix + "Mui-focusVisible"] = {
                    border: "1px solid white",
                    boxShadow: "0 0 0 2px " + ((primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) || primaryLight) + " !important"
                },
                _e["&." + classPrefix + "Mui-focusVisible." + classPrefix + "MuiButton-outlinedSizeSmall"] = {
                    boxShadow: "0 0 0 1px " + ((primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) || primaryLight) + " !important"
                },
                _e),
            outlinedPrimary: (_f = {
                    color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                    '&:hover': {
                        border: "1px solid " + primaryDark,
                        backgroundColor: defaultBackground
                    },
                    '&:active': {
                        borderColor: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400],
                        boxShadow: "0px 0px 0px 1px " + (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) + " !important"
                    }
                },
                _f["& ." + prefix + "MuiButton-startIcon"] = {
                    color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary
                },
                _f["& ." + prefix + "MuiButton-endIcon"] = {
                    color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary
                },
                _f),
            outlinedSecondary: {
                color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                '&:hover': {
                    border: "1px solid " + secondaryDark,
                    backgroundColor: defaultBackground
                }
            },
            containedPrimary: (_g = {},
                _g["&." + classPrefix + "Mui-focusVisible"] = {
                    backgroundColor: (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) + " !important",
                    border: "1px solid white",
                    boxShadow: "0 0 0 2px " + ((primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) || primaryLight) + " !important"
                },
                _g["&." + classPrefix + "Mui-focusVisible." + classPrefix + "MuiButton-containedSizeSmall"] = {
                    boxShadow: "0 0 0 1px " + ((primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) || primaryLight) + " !important"
                },
                _g),
            containedSecondary: (_h = {},
                _h["&." + classPrefix + "Mui-focusVisible"] = {
                    backgroundColor: (secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.main) + " !important",
                    border: "1px solid white",
                    boxShadow: "0 0 0 2px " + ((secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor[400]) || secondaryLight) + " !important"
                },
                _h["&." + classPrefix + "Mui-focusVisible." + classPrefix + "MuiButton-containedSizeSmall"] = {
                    boxShadow: "0 0 0 1px " + ((secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor[400]) || secondaryLight) + " !important"
                },
                _h)
        },
        MuiButtonGroup: {
            groupedContainedPrimary: {
                '&:not(:last-child)': {
                    borderColor: defaultBackground
                }
            },
            groupedOutlined: {
                '&:active': {
                    zIndex: 1,
                    borderColor: (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) + " !important"
                }
            },
            groupedTextPrimary: {
                border: "1px solid " + ((_76 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _76 === void 0 ? void 0 : _76.grey[70]) + " !important",
                '&:not(:last-child)': {
                    marginRight: -1
                }
            }
        },
        MuiDialogContentText: {
            root: {
                color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary
            }
        },
        MuiDialogTitle: {
            root: (_j = {
                    padding: 24,
                    paddingBottom: 4
                },
                _j["& ." + prefix + "MuiTypography-root"] = {
                    fontWeight: 600
                },
                _j)
        },
        MuiDialogActions: {
            root: {
                padding: 24,
                paddingTop: 16
            }
        },
        MuiDialog: {
            paper: {
                boxShadow: '0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)'
            }
        },
        MuiBackdrop: {
            root: {
                backgroundColor: 'rgba(23, 43, 77 ,0.3)'
            }
        },
        MuiToggleButton: {
            root: {
                fontWeight: 600,
                backgroundColor: defaultBackground,
                color: textPalette === null || textPalette === void 0 ? void 0 : textPalette.primary,
                borderColor: grey70 + " !important",
                '&:hover': {
                    backgroundColor: defaultBackground
                },
                '&$selected': (_k = {
                        backgroundColor: (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main) + " !important",
                        borderColor: (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main) + " !important",
                        borderRight: "1px solid " + (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main) + " !important",
                        '&:hover': {
                            backgroundColor: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main
                        }
                    },
                    _k["& ." + prefix + "MuiToggleButton-label"] = {
                        color: defaultBackground
                    },
                    _k),
                '&$disabled': (_l = {
                        backgroundColor: grey40
                    },
                    _l["& ." + prefix + "MuiToggleButton-label"] = {
                        color: grey100
                    },
                    _l),
                height: 32,
                fontSize: 14
            },
            sizeSmall: {
                height: 24,
                fontSize: 12
            },
            sizeLarge: {
                height: 40,
                fontSize: 16
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        MuiSwitch: {
            root: {
                width: 48,
                height: 24,
                padding: 0,
                display: 'flex',
                margin: 8
            },
            switchBase: {
                padding: 2,
                color: (_77 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _77 === void 0 ? void 0 : _77.background["default"],
                '&:hover': {
                    backgroundColor: 'inherit'
                },
                '&$checked': {
                    transform: 'translateX(24px)',
                    color: ((_78 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _78 === void 0 ? void 0 : _78.background["default"]) + " !important",
                    '& + $track': {
                        opacity: 1,
                        borderColor: (_79 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _79 === void 0 ? void 0 : _79.action.disabled,
                        backgroundColor: (_80 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _80 === void 0 ? void 0 : _80.action.disabled
                    }
                }
            },
            colorPrimary: {
                '&$disabled': {
                    color: ((_81 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _81 === void 0 ? void 0 : _81.background["default"]) + " !important",
                    '& + $track': {
                        opacity: 0.8,
                        borderColor: (_82 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _82 === void 0 ? void 0 : _82.action.disabled,
                        backgroundColor: (_83 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _83 === void 0 ? void 0 : _83.action.disabled
                    },
                    '&$checked': {
                        '& + $track': {
                            opacity: 0.5,
                            borderColor: (_84 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _84 === void 0 ? void 0 : _84.primary.main,
                            backgroundColor: (_85 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _85 === void 0 ? void 0 : _85.primary.main
                        }
                    }
                },
                '&$checked': {
                    '& + $track': {
                        borderColor: (_86 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _86 === void 0 ? void 0 : _86.primary.main
                    }
                }
            },
            colorSecondary: {
                '&$disabled': {
                    color: ((_87 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _87 === void 0 ? void 0 : _87.background["default"]) + " !important",
                    '& + $track': {
                        opacity: 0.8,
                        borderColor: (_88 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _88 === void 0 ? void 0 : _88.action.disabled,
                        backgroundColor: (_89 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _89 === void 0 ? void 0 : _89.action.disabled
                    },
                    '&$checked': {
                        '& + $track': {
                            opacity: 0.5,
                            borderColor: (_90 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _90 === void 0 ? void 0 : _90.secondary.main,
                            backgroundColor: (_91 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _91 === void 0 ? void 0 : _91.secondary.main
                        }
                    }
                },
                '&$checked': {
                    '& + $track': {
                        borderColor: (_92 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _92 === void 0 ? void 0 : _92.secondary.main
                    }
                }
            },
            thumb: {
                width: 20,
                height: 20,
                boxShadow: 'none'
            },
            track: {
                border: "1px solid " + ((_93 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _93 === void 0 ? void 0 : _93.action.disabled),
                borderRadius: 12,
                opacity: 1,
                backgroundColor: (_94 = DefaultEpilotTheme_1.DefaultEpilotTheme === null || DefaultEpilotTheme_1.DefaultEpilotTheme === void 0 ? void 0 : DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _94 === void 0 ? void 0 : _94.action.disabled
            },
            sizeSmall: (_m = {
                    width: 28,
                    height: 16,
                    padding: 0
                },
                _m["& ." + prefix + "MuiSwitch-switchBase"] = (_o = {
                        padding: '2px !important',
                        '&$checked': {
                            transform: 'translateX(12px) !important'
                        }
                    },
                    _o["& ." + prefix + "MuiSwitch-thumb"] = {
                        width: 12,
                        height: 12
                    },
                    _o),
                _m)
        },
        MuiTooltip: {
            tooltip: {
                backgroundColor: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[800],
                padding: 8,
                fontSize: 14,
                lineHeight: '18px'
            },
            arrow: {
                color: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[800]
            }
        },
        MuiFilledInput: {
            root: {
                border: "1px solid " + grey70,
                backgroundColor: grey20,
                borderRadius: borderRadius,
                '&:hover': {
                    backgroundColor: grey20
                },
                '&$focused': {
                    backgroundColor: grey20,
                    border: "1px solid " + (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400])
                },
                '&.Mui-error': {
                    borderColor: errorColor === null || errorColor === void 0 ? void 0 : errorColor.main
                },
                '&$disabled': {
                    backgroundColor: grey40
                }
            }
        },
        MuiOutlinedInput: {
            root: (_p = {
                    backgroundColor: defaultBackground,
                    '& input': {
                        paddingTop: 10.5,
                        paddingBottom: 10.5
                    }
                },
                _p["& ." + prefix + "MuiOutlinedInput-notchedOutline"] = {
                    borderColor: grey70
                },
                _p['&:hover'] = (_q = {
                        backgroundColor: grey20
                    },
                    _q["& ." + prefix + "MuiOutlinedInput-notchedOutline"] = {
                        borderColor: grey70
                    },
                    _q),
                _p['&$focused'] = (_r = {
                        backgroundColor: '#ffffff'
                    },
                    _r["& ." + prefix + "MuiOutlinedInput-notchedOutline"] = {
                        borderColor: (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor[400]) + " !important",
                        borderWidth: 1
                    },
                    _r),
                _p['&$disabled'] = (_s = {
                        backgroundColor: grey40
                    },
                    _s["& ." + prefix + "MuiOutlinedInput-notchedOutline"] = {
                        borderColor: grey70
                    },
                    _s),
                _p),
            inputMarginDense: {
                '&$input': {
                    paddingTop: 6.5,
                    paddingBottom: 6.5
                }
            },
            notchedOutline: {
                '& legend': {
                    maxWidth: 0
                }
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                minHeight: 32
            },
            option: {
                '&:hover': {
                    backgroundColor: actionHoverColor
                },
                "&[aria-selected='true']": {
                    backgroundColor: actionHoverColor,
                    color: (primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main) + " !important"
                }
            },
            paper: {
                boxShadow: elevation8
            }
        },
        MuiCssBaseline: tslib_1.__assign({ '@global': {
                '@font-face': extFonts,
                '.Mui-selected': {
                    color: primaryColor === null || primaryColor === void 0 ? void 0 : primaryColor.main,
                    backgroundColor: actionHoverColor + " !important"
                },
                '.Mui-focusVisible': {
                    backgroundColor: defaultBackground + " !important"
                },
                input: {
                    '&::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 0
                    }
                }
            } }, (_95 = params.muiOverrides) === null || _95 === void 0 ? void 0 : _95.MuiCssBaseline)
    }, params.muiOverrides);
    return {
        typography: {
            fontWeightRegular: ((_96 = params.typography) === null || _96 === void 0 ? void 0 : _96.fontWeightRegular) || ((_97 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _97 === void 0 ? void 0 : _97.fontWeightRegular),
            fontWeightBold: ((_98 = params.typography) === null || _98 === void 0 ? void 0 : _98.fontWeightBold) || ((_99 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _99 === void 0 ? void 0 : _99.fontWeightBold),
            fontSize: ((_100 = params.typography) === null || _100 === void 0 ? void 0 : _100.fontSize) || ((_101 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _101 === void 0 ? void 0 : _101.fontSize),
            body1: ((_102 = params.typography) === null || _102 === void 0 ? void 0 : _102.body1) || ((_103 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _103 === void 0 ? void 0 : _103.body1),
            body2: ((_104 = params.typography) === null || _104 === void 0 ? void 0 : _104.body2) || ((_105 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _105 === void 0 ? void 0 : _105.body2),
            caption: ((_106 = params.typography) === null || _106 === void 0 ? void 0 : _106.caption) || ((_107 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _107 === void 0 ? void 0 : _107.caption),
            subtitle1: ((_108 = params.typography) === null || _108 === void 0 ? void 0 : _108.subtitle1) || ((_109 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _109 === void 0 ? void 0 : _109.subtitle1),
            subtitle2: ((_110 = params.typography) === null || _110 === void 0 ? void 0 : _110.subtitle2) || ((_111 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _111 === void 0 ? void 0 : _111.subtitle2),
            fontFamily: (((_112 = params.typography) === null || _112 === void 0 ? void 0 : _112.fontFamily) || ((_113 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _113 === void 0 ? void 0 : _113.fontFamily)) + " !important",
            button: ((_114 = params.typography) === null || _114 === void 0 ? void 0 : _114.button) || ((_115 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _115 === void 0 ? void 0 : _115.button),
            h1: ((_116 = params.typography) === null || _116 === void 0 ? void 0 : _116.h1) || ((_117 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _117 === void 0 ? void 0 : _117.h1),
            h2: ((_118 = params.typography) === null || _118 === void 0 ? void 0 : _118.h2) || ((_119 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _119 === void 0 ? void 0 : _119.h2),
            h3: ((_120 = params.typography) === null || _120 === void 0 ? void 0 : _120.h3) || ((_121 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _121 === void 0 ? void 0 : _121.h3),
            h4: ((_122 = params.typography) === null || _122 === void 0 ? void 0 : _122.h4) || ((_123 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _123 === void 0 ? void 0 : _123.h4),
            h5: ((_124 = params.typography) === null || _124 === void 0 ? void 0 : _124.h5) || ((_125 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _125 === void 0 ? void 0 : _125.h5),
            h6: ((_126 = params.typography) === null || _126 === void 0 ? void 0 : _126.h6) || ((_127 = DefaultEpilotTheme_1.DefaultEpilotTheme.typography) === null || _127 === void 0 ? void 0 : _127.h6)
        },
        shadows: DefaultEpilotTheme_1.DefaultEpilotTheme.shadows,
        palette: {
            primary: tslib_1.__assign(tslib_1.__assign({}, primaryColor), { dark: primaryDark }),
            secondary: tslib_1.__assign(tslib_1.__assign({}, secondaryColor), { dark: secondaryDark }),
            success: tslib_1.__assign(tslib_1.__assign({}, successColor), { dark: (successColor === null || successColor === void 0 ? void 0 : successColor.dark) ? successColor === null || successColor === void 0 ? void 0 : successColor.dark : (successColor === null || successColor === void 0 ? void 0 : successColor.main) ? styles_1.darken(successColor === null || successColor === void 0 ? void 0 : successColor.main, 0.1)
                    : null }),
            "default": tslib_1.__assign(tslib_1.__assign({}, defaultColor), { dark: (defaultColor === null || defaultColor === void 0 ? void 0 : defaultColor.dark) ? defaultColor === null || defaultColor === void 0 ? void 0 : defaultColor.dark : (defaultColor === null || defaultColor === void 0 ? void 0 : defaultColor.main) ? styles_1.darken(defaultColor === null || defaultColor === void 0 ? void 0 : defaultColor.main, 0.1)
                    : null }),
            info: tslib_1.__assign(tslib_1.__assign({}, infoColor), { dark: (infoColor === null || infoColor === void 0 ? void 0 : infoColor.dark) ? infoColor === null || infoColor === void 0 ? void 0 : infoColor.dark : (infoColor === null || infoColor === void 0 ? void 0 : infoColor.main) ? styles_1.darken(infoColor === null || infoColor === void 0 ? void 0 : infoColor.main, 0.1)
                    : null }),
            warning: tslib_1.__assign(tslib_1.__assign({}, warningColor), { dark: (warningColor === null || warningColor === void 0 ? void 0 : warningColor.dark) ? warningColor === null || warningColor === void 0 ? void 0 : warningColor.dark : (warningColor === null || warningColor === void 0 ? void 0 : warningColor.main) ? styles_1.darken(warningColor === null || warningColor === void 0 ? void 0 : warningColor.main, 0.1)
                    : null }),
            error: tslib_1.__assign(tslib_1.__assign({}, errorColor), { dark: (errorColor === null || errorColor === void 0 ? void 0 : errorColor.dark) ? errorColor === null || errorColor === void 0 ? void 0 : errorColor.dark : (errorColor === null || errorColor === void 0 ? void 0 : errorColor.main) ? styles_1.darken(errorColor === null || errorColor === void 0 ? void 0 : errorColor.main, 0.1)
                    : null }),
            accent1: tslib_1.__assign(tslib_1.__assign({}, accent1Color), { dark: (accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.dark) ? accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.dark : (accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.main) ? styles_1.darken(accent1Color === null || accent1Color === void 0 ? void 0 : accent1Color.main, 0.1)
                    : null }),
            accent2: tslib_1.__assign(tslib_1.__assign({}, accent2Color), { dark: (accent2Color === null || accent2Color === void 0 ? void 0 : accent2Color.dark) ? accent2Color === null || accent2Color === void 0 ? void 0 : accent2Color.dark : (accent2Color === null || accent2Color === void 0 ? void 0 : accent2Color.main) ? styles_1.darken(accent2Color === null || accent2Color === void 0 ? void 0 : accent2Color.main, 0.1)
                    : null }),
            tertiary: tslib_1.__assign(tslib_1.__assign({}, tertiaryColor), { dark: (tertiaryColor === null || tertiaryColor === void 0 ? void 0 : tertiaryColor.dark) ? tertiaryColor === null || tertiaryColor === void 0 ? void 0 : tertiaryColor.dark : (tertiaryColor === null || tertiaryColor === void 0 ? void 0 : tertiaryColor.main) ? styles_1.darken(tertiaryColor === null || tertiaryColor === void 0 ? void 0 : tertiaryColor.main, 0.1)
                    : null }),
            grey: {
                '10': ((_129 = (_128 = params.palette) === null || _128 === void 0 ? void 0 : _128.grey) === null || _129 === void 0 ? void 0 : _129[10]) || ((_131 = (_130 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _130 === void 0 ? void 0 : _130.grey) === null || _131 === void 0 ? void 0 : _131[10]),
                '20': grey20,
                '30': grey30,
                '40': ((_133 = (_132 = params.palette) === null || _132 === void 0 ? void 0 : _132.grey) === null || _133 === void 0 ? void 0 : _133[40]) || ((_135 = (_134 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _134 === void 0 ? void 0 : _134.grey) === null || _135 === void 0 ? void 0 : _135[40]),
                '50': grey50,
                '70': grey70,
                '100': ((_137 = (_136 = params.palette) === null || _136 === void 0 ? void 0 : _136.grey) === null || _137 === void 0 ? void 0 : _137[100]) || ((_139 = (_138 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _138 === void 0 ? void 0 : _138.grey) === null || _139 === void 0 ? void 0 : _139[100]),
                '200': ((_141 = (_140 = params.palette) === null || _140 === void 0 ? void 0 : _140.grey) === null || _141 === void 0 ? void 0 : _141[200]) || ((_143 = (_142 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _142 === void 0 ? void 0 : _142.grey) === null || _143 === void 0 ? void 0 : _143[200]),
                '300': ((_145 = (_144 = params.palette) === null || _144 === void 0 ? void 0 : _144.grey) === null || _145 === void 0 ? void 0 : _145[300]) || ((_147 = (_146 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _146 === void 0 ? void 0 : _146.grey) === null || _147 === void 0 ? void 0 : _147[300]),
                '400': ((_149 = (_148 = params.palette) === null || _148 === void 0 ? void 0 : _148.grey) === null || _149 === void 0 ? void 0 : _149[400]) || ((_151 = (_150 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _150 === void 0 ? void 0 : _150.grey) === null || _151 === void 0 ? void 0 : _151[400]),
                '500': ((_153 = (_152 = params.palette) === null || _152 === void 0 ? void 0 : _152.grey) === null || _153 === void 0 ? void 0 : _153[500]) || ((_155 = (_154 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _154 === void 0 ? void 0 : _154.grey) === null || _155 === void 0 ? void 0 : _155[500]),
                '600': ((_157 = (_156 = params.palette) === null || _156 === void 0 ? void 0 : _156.grey) === null || _157 === void 0 ? void 0 : _157[600]) || ((_159 = (_158 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _158 === void 0 ? void 0 : _158.grey) === null || _159 === void 0 ? void 0 : _159[600]),
                '700': ((_161 = (_160 = params.palette) === null || _160 === void 0 ? void 0 : _160.grey) === null || _161 === void 0 ? void 0 : _161[700]) || ((_163 = (_162 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _162 === void 0 ? void 0 : _162.grey) === null || _163 === void 0 ? void 0 : _163[700]),
                '800': ((_165 = (_164 = params.palette) === null || _164 === void 0 ? void 0 : _164.grey) === null || _165 === void 0 ? void 0 : _165[800]) || ((_167 = (_166 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _166 === void 0 ? void 0 : _166.grey) === null || _167 === void 0 ? void 0 : _167[800]),
                '900': ((_169 = (_168 = params.palette) === null || _168 === void 0 ? void 0 : _168.grey) === null || _169 === void 0 ? void 0 : _169[900]) || ((_171 = (_170 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _170 === void 0 ? void 0 : _170.grey) === null || _171 === void 0 ? void 0 : _171[900]),
                A100: ((_173 = (_172 = params.palette) === null || _172 === void 0 ? void 0 : _172.grey) === null || _173 === void 0 ? void 0 : _173.A100) || ((_175 = (_174 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _174 === void 0 ? void 0 : _174.grey) === null || _175 === void 0 ? void 0 : _175.A100),
                A200: ((_177 = (_176 = params.palette) === null || _176 === void 0 ? void 0 : _176.grey) === null || _177 === void 0 ? void 0 : _177.A200) || ((_179 = (_178 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _178 === void 0 ? void 0 : _178.grey) === null || _179 === void 0 ? void 0 : _179.A200),
                A400: ((_181 = (_180 = params.palette) === null || _180 === void 0 ? void 0 : _180.grey) === null || _181 === void 0 ? void 0 : _181.A400) || ((_183 = (_182 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _182 === void 0 ? void 0 : _182.grey) === null || _183 === void 0 ? void 0 : _183.A400),
                A700: ((_185 = (_184 = params.palette) === null || _184 === void 0 ? void 0 : _184.grey) === null || _185 === void 0 ? void 0 : _185.A700) || ((_187 = (_186 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _186 === void 0 ? void 0 : _186.grey) === null || _187 === void 0 ? void 0 : _187.A700)
            },
            action: {
                hover: actionHoverColor,
                selected: ((_189 = (_188 = params.palette) === null || _188 === void 0 ? void 0 : _188.action) === null || _189 === void 0 ? void 0 : _189.selected) || ((_191 = (_190 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _190 === void 0 ? void 0 : _190.action) === null || _191 === void 0 ? void 0 : _191.selected),
                disabled: ((_193 = (_192 = params.palette) === null || _192 === void 0 ? void 0 : _192.action) === null || _193 === void 0 ? void 0 : _193.disabled) || ((_195 = (_194 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _194 === void 0 ? void 0 : _194.action) === null || _195 === void 0 ? void 0 : _195.disabled),
                active: ((_197 = (_196 = params.palette) === null || _196 === void 0 ? void 0 : _196.action) === null || _197 === void 0 ? void 0 : _197.active) || ((_199 = (_198 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _198 === void 0 ? void 0 : _198.action) === null || _199 === void 0 ? void 0 : _199.active),
                focus: ((_201 = (_200 = params.palette) === null || _200 === void 0 ? void 0 : _200.action) === null || _201 === void 0 ? void 0 : _201.focus) || ((_203 = (_202 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _202 === void 0 ? void 0 : _202.action) === null || _203 === void 0 ? void 0 : _203.focus)
            },
            background: ((_204 = params.palette) === null || _204 === void 0 ? void 0 : _204.background) || ((_205 = DefaultEpilotTheme_1.DefaultEpilotTheme.palette) === null || _205 === void 0 ? void 0 : _205.background),
            text: tslib_1.__assign({}, textPalette),
            divider: dividerColor
        },
        overrides: overrides,
        shape: {
            borderRadius: borderRadius
        },
        // DEFAULT PROPS
        props: tslib_1.__assign({ MuiInputLabel: {
                shrink: true
            }, MuiButtonGroup: tslib_1.__assign({ disableRipple: disableRipple }, (_206 = params.muiProps) === null || _206 === void 0 ? void 0 : _206.MuiButtonGroup), MuiButton: {
                disableElevation: true
            }, MuiSwitch: {
                color: 'primary'
            }, MuiButtonBase: {
                disableRipple: disableRipple
            }, MuiRadio: tslib_1.__assign({ disableRipple: disableRipple }, (_207 = params.muiProps) === null || _207 === void 0 ? void 0 : _207.MuiRadio), MuiCheckbox: {
                color: 'primary'
            }, MuiIconButton: tslib_1.__assign({ disableRipple: disableRipple }, (_208 = params.muiProps) === null || _208 === void 0 ? void 0 : _208.MuiIconButton), MuiList: tslib_1.__assign({ disablePadding: true }, (_209 = params.muiProps) === null || _209 === void 0 ? void 0 : _209.MuiList), MuiTooltip: tslib_1.__assign({ arrow: true }, (_210 = params.muiProps) === null || _210 === void 0 ? void 0 : _210.MuiTooltip), MuiFilledInput: {
                disableUnderline: true
            }, MuiTextField: {
                variant: 'filled',
                InputLabelProps: {
                    shrink: true
                }
            }, MuiSelect: {
                MenuProps: {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    getContentAnchorEl: null,
                    style: {
                        marginTop: 4
                    }
                }
            }, MuiAppBar: {
                color: 'primary'
            } }, params.muiProps),
        spacing: params.spacing || DefaultEpilotTheme_1.DefaultEpilotTheme.spacing,
        breakpoints: tslib_1.__assign({}, params === null || params === void 0 ? void 0 : params.breakpoints)
    };
}
exports.parseMuiTheme = parseMuiTheme;
//# sourceMappingURL=mapping.js.map